import React, { useState } from 'react';
import './Faq.css'; // Ensure to import your CSS file
import isoBadge from '../assets/iso-certificate.png';
import isoBadge2 from '../assets/ascbb.png';
import isoBadge3 from '../assets/global.png';    



const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    { question: "What is the primary function of your extension?", answer: "Our extension is designed to protect your online privacy by monitoring for sensitive information such as credit card numbers and passwords in real-time. It alerts you before any potentially harmful data is uploaded, ensuring you stay in control of your personal information while browsing." },
    { question: "How do I install the extension?", answer: "Installing our extension is a breeze! Simply click the 'Add to Browser' button on our website. Follow the straightforward prompts to complete the installation, and you'll be ready to enhance your online security in just a few minutes." },
    { question: "How does the extension keep my data safe?", answer: "Your safety is our top priority. The extension runs seamlessly in the background, scanning for sensitive information without storing or sharing your data. When it detects potential risks, it sends you real-time alerts, allowing you to take action before any information is exposed." },
    { question: "Can I customize my alert settings?", answer: "Yes, absolutely! You have full control over your alert preferences. Tailor your notifications based on the type and sensitivity of information you wish to monitor, ensuring that you only receive alerts that matter to you." },
    { question: "What should I do if I receive an alert?", answer: "If you receive an alert, it indicates that sensitive information may be detected. You can review the details of the alert and decide whether to proceed with the action or cancel it. This empowers you to make informed decisions about your online privacy." },
    { question: "Is the extension compatible with all browsers?", answer: "Our extension is designed to work with major browsers, including Chrome, Firefox, and Edge. This ensures that you can enjoy enhanced privacy protection no matter which browser you prefer for your online activities." },
    { question: "How can I access my alerts and privacy dashboard?", answer: "Once the extension is installed, you can easily access your personalized dashboard by clicking on the extension icon in your browser. This dashboard provides an overview of past alerts, risk levels, and insights into your data privacy." },
    { question: "Does the extension affect my browsing speed?", answer: "No, our extension is optimized to run efficiently without impacting your browsing experience. You can enjoy seamless web navigation while our extension quietly monitors your data in the background." },
    { question: "What should I do if I encounter issues with the extension?", answer: "If you experience any issues, we’re here to help! Visit our support page for troubleshooting tips, or contact our customer service team for personalized assistance. We're dedicated to ensuring your experience is smooth and secure." },
    { question: "Can I uninstall the extension if I no longer need it?", answer: "Yes, uninstalling the extension is quick and easy. Simply go to your browser’s extension settings, find our extension, and click 'Remove.' Your browsing experience will return to normal without any residual effects." },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-main-section" id="faq">
      <div className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              <h3>{faq.question}</h3>
              <span className="faq-toggle">{activeIndex === index ? '-' : '+'}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      </div>
      <div className="footer-certification">
  <h3 className="certification-title">Certified for Excellence & Trust</h3>
  <div className="certification-logos">
    <img src={isoBadge} alt="ISO Certified" className="iso-badge"/>
    <img src={isoBadge3} alt="ISO Certified" className="iso-badge3"/>
    <img src={isoBadge2} alt="ISO Certified" className="iso-badge2"/>
  </div>
  <p className="certification-text">
    We are proud to be <strong>ISO Certified</strong>, ensuring the highest quality, security, and compliance standards.
  </p>
</div>
    </section>
  );
};

export default Faq;
